<template>
    <div class="container pb-4">

<div class="row py-4">
    <div class="col text-center">
        <a :href="`/sales`"><i class="fa-solid fa-arrow-left pr-1"></i>Back to sales</a>
    </div>
</div>

  <div class="row">

    <div :class="colClass">
        <div class="card mb-3">
        <div class="card-body">

          <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>
          <div v-else>

            <div v-if="item">
                <div class="pb-3 text-center">
                    <div v-if="item.product.images">
                      <a :href="makeProductLink(item.product)" target="_blank" title="View product">
                        <img v-if="item.product.images.length > 0" :src="item.product.images[0].url" style="height:4rem;" />
                        <img v-else src="/images/image-not-found.svg" style="height:4rem;" />
                      </a>
                    </div>
                    <div class="mt-2"><b>{{item.product.name}}</b></div>
                    <div>R {{item.product.price*item.quantity}} &bull; Qty {{item.quantity}}</div>
                </div>   
            </div>

            <div v-if="loadingUpdates" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>

            <div v-else-if="updates.length == 0" class="text-center">
                <div class="alert alert-warning py-1 mb-0"><i class="far fa-clock mr-2"></i>No shipping updates yet</div>
            </div>

            <table v-else class="table d-none d-md-table" style="line-height:1.3rem;">
                <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">Status</th>
                  <th class="first-right pl-3">Updated</th>
                </tr>
              </thead>
                <tbody>
                    <tr v-for="(update, index) in updates" :key="index">
                        <td class="pl-3">{{formatName(update.status.name)}}</td>
                        <td class="pl-3"><timeago
                        :datetime="update.created_at"
                        :auto-update="60"
                        :title="formatDateMoment(update.created_at)"></timeago>
                        </td>
                    </tr>
                </tbody>
                </table>

        </div>
        </div>
        </div>
    </div>

    <div class="col-md-3 text-center" v-if="item">

        <div v-if="item.return_reason_id">
          <div class="card">
              <div class="card-body">
                  <div><b>Product has been returned</b></div>
                  <div class="alert alert-warning py-1 mt-3 mb-0">{{item.reason.name}}</div>
              </div>
          </div>
        </div>

        <div v-else>

        <div v-if="updates.length == 0">
          <div class="card">
              <div class="card-body">
                  <a href="#/" @click="showModalShippingModal()"><i class="fas fa-plus-circle mr-2"></i>Create shipping label</a>
              </div>
          </div>
          <div class="card mt-3">
              <div class="card-body">
                  <a href="#/" class="debit" @click="showModalCancelOrder()"><i class="fas fa-times-circle mr-2"></i>Cancel order</a>
              </div>
          </div>
        </div>

          <div v-else-if="item.shipping_label">
          <div class="card">
              <div class="card-body">
                  <div><a :href="item.shipping_label" target="_blank"><i class="fas fa-plus-circle mr-2"></i>Download shipping label</a></div>
              </div>
          </div>
          <!-- <div class="card mt-3">
              <div class="card-body">
                  <a :href="item.shipping_sticker" target="_blank"><i class="fas fa-plus-circle mr-2"></i>Download shipping sticker</a>
              </div>
          </div> -->
          </div>

        </div>

    </div>

    </div>
  <shipping-modal v-if="item" :item="item" @update-page="updatePage"></shipping-modal>
  <cancel-order v-if="item" :item="item" @update-page="updatePage"></cancel-order>
</div>
    
</template> 

<script>
export default {
 props: ['id'],

  data() {
    return {
      order: {},
      item: null,
      updates: [],
      loading: false,
      loadingUpdates: false,
    };
  },

  created() {
    this.getUpdates();
    this.getProduct();
  },

  computed: {
    colClass() {
      if (!this.item) {
        return 'col-12';
      } else if (this.item.return_reason_id || this.item.shipping_label || this.updates.length == 0) {
        return 'col-md-9 pr-md-0';
      } else {
        return 'col-12';
      }
    },
  },

  methods: {

    updatePage() {
      this.getUpdates();
      this.getProduct();
    },

    showModalShippingModal() {
      this.$bvModal.show('bv-modal-shipping');
    },

    showModalCancelOrder() {
      this.$bvModal.show('bv-modal-cancel-order');
    },

    getProduct() {

      this.loading = true;

      axios
        .get('/sales/get/'+this.id)
        .then((response) => {
          this.item = response.data;
          this.loading = false;
        });
    },

    getUpdates() {
      this.loadingUpdates = true;
      axios.get(`/dashboard/${this.id}/updates`).
      then((response) => {
        this.updates = response.data;
        this.loadingUpdates = false;
      });
    },

  },
};
</script>